'use client';

import { Card } from '../Card';
import { Container } from '../Container';
import { AlgoliaInfiniteScroll } from '../AlgoliaInfiniteScroll';
import { useStats, Configure } from 'react-instantsearch';
import { Search } from '../Inputs/Search';
import { useRouter, useSearchParams } from 'next/navigation';
import { Text } from '../Text';
import { getCardLayout, getCardSize, formatDate } from '../CardsGridFilter';
import { useState } from 'react';
import { tv } from 'tailwind-variants';
import { AlgoliaSearch } from '../AlgoliaSearch';

export type SearchResultsProps = {
	className?: string;
	locale: string;
	channelVisibility: string;
};

const styles = tv({
	slots: {
		items: 'grid gap-responsive-lg',
	},
	variants: {
		layout: {
			'4wide': {
				items: 'sm:grid-cols-2 md:grid-cols-4',
			},
			'3wide': {
				items: 'md:grid-cols-3',
			},
			'2wide': {
				items: 'lg:grid-cols-2',
			},
		},
	},
});

export function SearchResults(props: SearchResultsProps) {
	const layout = '3wide';
	const { items } = styles({ layout });

	const router = useRouter();
	const searchParams = useSearchParams();

	const updateSearchParams = (key: string, value: string) => {
		setCurrentQuery(value);
		const params = new URLSearchParams(searchParams.toString());
		params.set(key, value);

		// Update the URL with the new search parameters
		router.push(`?${params.toString()}`);
	};

	// const filterNavOptions = ['articleType', 'filters.topics', 'filters.solutions', 'filters.products'];

	// const [filtersStates, setFiltersStates] = useState<Record<string, boolean | undefined> | undefined>(
	// 	filterNavOptions && filterNavOptions.length > 0
	// 		? filterNavOptions.reduce((acc, filter) => ({ ...acc, [filter.replace('filters.', '')]: undefined }), {})
	// 		: undefined,
	// );

	const initialQuery = searchParams.get('query') || '';
	const [currentQuery, setCurrentQuery] = useState(initialQuery);
	const currentDate = Math.floor(new Date().getTime() / 1000);

	return (
		<section className={props.className} data-component='CardListing'>
			<Container className='flex flex-col gap-responsive-lg'>
				<AlgoliaSearch indexName='updateddata'>
					<Configure
						hitsPerPage={12}
						filters={`language:${props.locale} AND channelVisibility:${props.channelVisibility} AND publishDate_sort < ${currentDate} AND NOT publishDate_sort:null`}
					/>
					<div className='flex flex-col gap-3 items-center mb-24'>
						<CustomStats />
						<Text as='h2' className={``} styleType='heading-lg'>
							{currentQuery}
						</Text>
						<Search initialQuery={initialQuery} updateSearchParams={updateSearchParams} />
					</div>
					<AlgoliaInfiniteScroll
						className={items()}
						hitComponent={({ hit, index }) => (
							<Card
								key={index}
								title={hit.title}
								overline={hit.articleType}
								image={hit.featuredImage}
								href={hit.href}
								meta={[hit.authors?.[0]?.name ?? '', formatDate(hit.publishDate)]}
								layout={getCardLayout(layout, index)}
								size={getCardSize(layout, index)}
							/>
						)}
					/>
				</AlgoliaSearch>
			</Container>
		</section>
	);
}

function CustomStats() {
	const { nbHits } = useStats();

	return (
		<Text as='span' className={``} styleType='editorial-md-semibold'>
			{nbHits.toLocaleString()} search results for
		</Text>
	);
}
